// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"DLCFile_pageContainer__2ROXX","title":"DLCFile_title__1VP16","description":"DLCFile_description__1b9MA"};